var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleConnector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 72,
  fill: "none",
  viewBox: "0 0 111 72"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  d: "M21 .5v71H0V.5h21Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  fillRule: "evenodd",
  d: "M110.5.5H21v21h89.5V.5Z",
  clipRule: "evenodd"
})));
export { SvgAngleConnector as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTExIiBoZWlnaHQ9IjcyIiB2aWV3Qm94PSIwIDAgMTExIDcyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjEgMC41MDAwMDRWMjEuNVY3MS41SDBWMC41MDAwMDRIMjFaIiBmaWxsPSIjNTM1NjVCIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExMC41IDAuNUwyMSAwLjUwMDAwNFYyMS41TDExMC41IDIxLjVWMC41WiIgZmlsbD0iIzUzNTY1QiIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg==";